import apiClient from "../client";

// GET /api/allocation-requests
// PMO: pass status=SUBMITTED (Needs PMO), status=PMO_APPROVED (At SCG),
//      status=ACTIVE (Approved), status=REJECTED, or no status (All)
// status values: SUBMITTED | PMO_APPROVED | ACTIVE | REJECTED
export const getAllocationRequests = async (params = {}) => {
  const response = await apiClient.get("/allocation-requests", { params });
  return response.data;
};

// GET /api/allocation-requests/{id}
// Full detail of a single request — used for review drawer
export const getAllocationRequestById = async (id) => {
  const response = await apiClient.get(`/allocation-requests/${id}`);
  return response.data;
};

// POST /api/approvals/{requestId}/approve
// PMO calls when status=SUBMITTED → moves to PMO_APPROVED
// SCG calls when status=PMO_APPROVED → fires atomic transaction → ACTIVE
// Body: { comments } — optional for approval
export const approveRequest = async (requestId, comments = "") => {
  const response = await apiClient.post(`/approvals/${requestId}/approve`, { comments });
  return response.data;
};

// POST /api/approvals/{requestId}/reject
// Body: { comments } — REQUIRED for rejection
export const rejectRequest = async (requestId, comments) => {
  const response = await apiClient.post(`/approvals/${requestId}/reject`, { comments });
  return response.data;
};